import Dialog from '@mui/material/Dialog';
import { Button } from 'components/v2/atoms/button';

interface ConfirmDialogType {
  open: boolean;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  confirmVariant?: 'default' | 'defaultGreen' | 'redDefault';
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmDialog = ({
  open,
  title,
  message,
  confirmText = 'OK',
  cancelText = 'キャンセル',
  confirmVariant = 'defaultGreen',
  onConfirm,
  onCancel,
}: ConfirmDialogType) => {
  if (!open) return null;
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth="md"
      slotProps={{
        backdrop: {
          style: {
            backgroundColor: 'rgba(0, 0, 0, 0.30)',
          },
        },
      }}
      PaperProps={{
        style: {
          backgroundColor: 'transparent',
          boxShadow: 'none',
        },
      }}
    >
      <div className="min-w-80 max-w-md rounded-lg border bg-white p-6 md:min-w-[448px]">
        {/* Title */}
        <h3 className="mb-6 text-lg font-semibold text-pp-text-primary">
          {title}
        </h3>

        {/* Message */}
        {message && (
          <p className="mb-6 text-sm text-pp-text-secondary">{message}</p>
        )}

        {/* Actions */}
        <div className="flex justify-end gap-3">
          <Button
            onClick={onCancel}
            variant="default"
            size="sm"
            className="px-4 py-2"
          >
            {cancelText}
          </Button>
          <Button
            onClick={onConfirm}
            variant={confirmVariant}
            size="sm"
            className="px-4 py-2"
          >
            {confirmText}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default ConfirmDialog;
